import React from "react"

const Title = ({ title, subTitle }) => {
  return (
    <div className="section-title">
      <h2>{title || "default title"}</h2>
      { subTitle && (
        <h5>{subTitle}</h5>
      )}
    </div>
  )
}

export default Title
